





































import { Component, Prop, Vue } from "vue-property-decorator";
import VueEvent from "../../core/decorator/VueEvent";

@Component({
  components: {}
})
export default class OtherTextSpanComponent extends Vue {
  @Prop({ type: String, required: true })
  private tag!: string;

  @Prop({ type: Array, required: true })
  private spans!: any[];

  private get listeners() {
    return {
      ...this.$listeners
    };
  }

  @VueEvent
  private onChangeChecked(index: number, value: boolean) {
    this.$emit("check", index, value);
  }

  @VueEvent
  private onChangeSelect(index: number, value: string) {
    this.$emit("select", index, value);
  }
}
